module.exports = __webpack_public_path__ + "media/application/images/2023/01_still-1600x900-934e4f849c4bba9a0f89cd1e05316cb6.png";